import { useTranslation } from 'react-i18next';
import Styles from './Footer.module.scss';
import { Links } from 'shared/infrastructure/Links';
import { APP_VERSION } from 'shared/app/constants';

export const Footer: React.FC = () => {
  const i18n = useTranslation();

  return (
    <div className={Styles.footerContainer}>
      <div className={Styles.legalLinks}>
        <div>
          <a target="_blank" rel="noopener noreferrer" href={Links.About}>
            {i18n.t('Login_About')}
          </a>
        </div>
        <div>
          <a target="_blank" rel="noopener noreferrer" href={Links.Imprint}>
            {i18n.t('Common_LegalInformation')}
          </a>
        </div>
        <div>
          <a target="_blank" rel="noopener noreferrer" href={Links.Privacy}>
            {i18n.t('PrivacySettings.PrivacySettingsPage.DataProtectionStatement')}
          </a>
        </div>
      </div>

      <div>{i18n.t('Common_Version', { version: APP_VERSION })}</div>
      <div>
        © 2016-{new Date().getFullYear()}&nbsp;
        <span className="text-nowrap">Löwenstein Medical Technology GmbH + Co. KG</span>
      </div>
    </div>
  );
};
